module.exports = __webpack_public_path__ + "static/img/calls-taken-fr.8c3d879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/calls-taken-fr.png
// module id = EV8Z
// module chunks = 0